import utils from '@/utils'

export const invoiceMonitoring = {
  namespaced: true,
  state: {
    list: {
      data: [],
      meta: {},
    },
    isListLoading: false,
  },
  getters: {
    list: (state) => {
      return state.list
    },
    isListLoading: (state) => {
      return state.listLoading
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data
    },
    setListLoading(state, data) {
      state.listLoading = data
    },
  },
  actions: {
    async getList({ commit, dispatch }, filters) {
      commit('setListLoading', true)
      try {
        const response = await axios.get(`/api/reports/invoice-monitoring`, {
          params: filters,
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'report/getList', error },
          { root: true }
        )
      } finally {
        commit('setListLoading', false)
      }
    },
  },
}

export const classroomMonitoring = {
  namespaced: true,
  state: {
    list: {
      data: [],
      meta: {},
    },
    isListLoading: true,
  },
  getters: {
    list: (state) => {
      return state.list
    },
    isListLoading: (state) => {
      return state.listLoading
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data
    },
    setListLoading(state, data) {
      state.listLoading = data
    },
  },
  actions: {
    async getList({ commit, dispatch }, filters) {
      commit('setListLoading', true)
      try {
        const response = await axios.get(`/api/reports/classroom-monitoring`, {
          params: filters,
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'report/getList', error },
          { root: true }
        )
      } finally {
        commit('setListLoading', false)
      }
    },
  },
}

export const report = {
  namespaced: true,
  modules: {
    invoiceMonitoring,
    classroomMonitoring,
  },
}
